import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'mvm-spinner-btn',
    templateUrl: './mvm-spinner-btn.template.html'
})

export class MVMSpinnerBtnComponent implements OnInit {

    @Input() isDisabled: boolean;
    @Input() isLoading: boolean;
    @Input() dataId: string;
    @Input() btnText: string;
    @Input() btnClass = 'btn--primary';
    @Input() btnType = 'submit';
    @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    constructor() { }

    ngOnInit() {}

    btnClicked(event: MouseEvent) {
        this.clicked.emit(event);
    }
}
